import { styled, StyledText } from '@raskrask-dk/rr-components'

export const NextTime = styled(StyledText, {
    textDecoration: 'underline',
})
